/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reserve Clubhouse Request Data Schema
 * @export
 * @interface ReserveClubhouseRequestData
 */
export interface ReserveClubhouseRequestData {
    /**
     * Reserve Clubhouse Request ID
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestId: string;
    /**
     * Reserve Clubhouse Request Begin Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestBeginDate: Date;
    /**
     * Reserve Clubhouse Request End Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestEndDate: Date;
    /**
     * Reserve Clubhouse Request Notes
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestNotes: string;
    /**
     * Reserve Clubhouse Request Status
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestStatus: string;
    /**
     * Reserve Clubhouse Request Response
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestResponse: string;
    /**
     * Reserve Clubhouse Request Created Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestCreatedDate: Date;
    /**
     * Reserve Clubhouse Request Updated Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestUpdatedDate: Date;
    /**
     * Reserve Clubhouse Request Deleted
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    reserveClubhouseRequestDeleted: string;
    /**
     * Account ID
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    accountId: string;
    /**
     * Account Username
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    accountUsername: string;
    /**
     * Account Email
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    accountEmail: string;
    /**
     * Account Created Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    accountCreatedDate: Date;
    /**
     * Account Updated Date
     * @type {Date}
     * @memberof ReserveClubhouseRequestData
     */
    accountUpdatedDate: Date;
    /**
     * Account Status
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    accountStatus: string;
    /**
     * Account Role
     * @type {string}
     * @memberof ReserveClubhouseRequestData
     */
    accountRole: string;
}

/**
 * Check if a given object implements the ReserveClubhouseRequestData interface.
 */
export function instanceOfReserveClubhouseRequestData(value: object): value is ReserveClubhouseRequestData {
    if (!('reserveClubhouseRequestId' in value) || value['reserveClubhouseRequestId'] === undefined) return false;
    if (!('reserveClubhouseRequestBeginDate' in value) || value['reserveClubhouseRequestBeginDate'] === undefined) return false;
    if (!('reserveClubhouseRequestEndDate' in value) || value['reserveClubhouseRequestEndDate'] === undefined) return false;
    if (!('reserveClubhouseRequestNotes' in value) || value['reserveClubhouseRequestNotes'] === undefined) return false;
    if (!('reserveClubhouseRequestStatus' in value) || value['reserveClubhouseRequestStatus'] === undefined) return false;
    if (!('reserveClubhouseRequestResponse' in value) || value['reserveClubhouseRequestResponse'] === undefined) return false;
    if (!('reserveClubhouseRequestCreatedDate' in value) || value['reserveClubhouseRequestCreatedDate'] === undefined) return false;
    if (!('reserveClubhouseRequestUpdatedDate' in value) || value['reserveClubhouseRequestUpdatedDate'] === undefined) return false;
    if (!('reserveClubhouseRequestDeleted' in value) || value['reserveClubhouseRequestDeleted'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('accountUsername' in value) || value['accountUsername'] === undefined) return false;
    if (!('accountEmail' in value) || value['accountEmail'] === undefined) return false;
    if (!('accountCreatedDate' in value) || value['accountCreatedDate'] === undefined) return false;
    if (!('accountUpdatedDate' in value) || value['accountUpdatedDate'] === undefined) return false;
    if (!('accountStatus' in value) || value['accountStatus'] === undefined) return false;
    if (!('accountRole' in value) || value['accountRole'] === undefined) return false;
    return true;
}

export function ReserveClubhouseRequestDataFromJSON(json: any): ReserveClubhouseRequestData {
    return ReserveClubhouseRequestDataFromJSONTyped(json, false);
}

export function ReserveClubhouseRequestDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveClubhouseRequestData {
    if (json == null) {
        return json;
    }
    return {
        
        'reserveClubhouseRequestId': json['reserve_clubhouse_request_id'],
        'reserveClubhouseRequestBeginDate': (new Date(json['reserve_clubhouse_request_begin_date'])),
        'reserveClubhouseRequestEndDate': (new Date(json['reserve_clubhouse_request_end_date'])),
        'reserveClubhouseRequestNotes': json['reserve_clubhouse_request_notes'],
        'reserveClubhouseRequestStatus': json['reserve_clubhouse_request_status'],
        'reserveClubhouseRequestResponse': json['reserve_clubhouse_request_response'],
        'reserveClubhouseRequestCreatedDate': (new Date(json['reserve_clubhouse_request_created_date'])),
        'reserveClubhouseRequestUpdatedDate': (new Date(json['reserve_clubhouse_request_updated_date'])),
        'reserveClubhouseRequestDeleted': json['reserve_clubhouse_request_deleted'],
        'accountId': json['account_id'],
        'accountUsername': json['account_username'],
        'accountEmail': json['account_email'],
        'accountCreatedDate': (new Date(json['account_created_date'])),
        'accountUpdatedDate': (new Date(json['account_updated_date'])),
        'accountStatus': json['account_status'],
        'accountRole': json['account_role'],
    };
}

export function ReserveClubhouseRequestDataToJSON(value?: ReserveClubhouseRequestData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reserve_clubhouse_request_id': value['reserveClubhouseRequestId'],
        'reserve_clubhouse_request_begin_date': ((value['reserveClubhouseRequestBeginDate']).toISOString()),
        'reserve_clubhouse_request_end_date': ((value['reserveClubhouseRequestEndDate']).toISOString()),
        'reserve_clubhouse_request_notes': value['reserveClubhouseRequestNotes'],
        'reserve_clubhouse_request_status': value['reserveClubhouseRequestStatus'],
        'reserve_clubhouse_request_response': value['reserveClubhouseRequestResponse'],
        'reserve_clubhouse_request_created_date': ((value['reserveClubhouseRequestCreatedDate']).toISOString()),
        'reserve_clubhouse_request_updated_date': ((value['reserveClubhouseRequestUpdatedDate']).toISOString()),
        'reserve_clubhouse_request_deleted': value['reserveClubhouseRequestDeleted'],
        'account_id': value['accountId'],
        'account_username': value['accountUsername'],
        'account_email': value['accountEmail'],
        'account_created_date': ((value['accountCreatedDate']).toISOString()),
        'account_updated_date': ((value['accountUpdatedDate']).toISOString()),
        'account_status': value['accountStatus'],
        'account_role': value['accountRole'],
    };
}

